import { render, staticRenderFns } from "./RequestedUpdatePassword.vue?vue&type=template&id=12b0e059"
import script from "./RequestedUpdatePassword.vue?vue&type=script&lang=js"
export * from "./RequestedUpdatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports